import { laptopMediumMax, mobileLargeMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-left: 1px solid ${({ theme }) => theme.keyline};
  color: ${({ theme }) => theme.textDark};
  padding: 0 5px;
  width: 100%;
  flex: 1;

  p {
    font-size: 14px;
    text-align: center;
  }

  svg {
    font-size: 22px;
    margin-bottom: 5px;
  }

  button {
    text-decoration: underline;
    font-size: 14px;
    color: ${({ theme }) => theme.textDark};

    &:hover {
      color: ${({ theme }) => theme.backgroundMid};
    }
  }
`;

export const Container = styled.section`
  background-color: ${({ theme }) => theme.background};
  border: 2px solid ${({ theme }) => theme.keyline};
  border-radius: 60px;
  margin-top: 40px;
  padding: 10px 30px;
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;
  gap: 15px 0;

  &.total-items-4,
  &.total-items-3 {
    max-width: 760px;
  }

  &.total-items-2 {
    max-width: 420px;
  }

  &.total-items-1 {
    max-width: 240px;
  }

  @media (${laptopMediumMax}) {
    &.total-items-6,
    &.total-items-5 {
      border-radius: 20px;
      padding: 10px;
      justify-content: flex-start;

      ${Item} {
        flex: 0 0 33.333%;
      }

      ${Item}:nth-child(4) {
        border-left: none;
      }
    }
  }

  @media (${mobileLargeMax}) {
    &.total-items-6,
    &.total-items-5 {
      ${Item} {
        flex: 0 0 50%;
      }

      ${Item}:nth-child(even) {
        border-left: 1px solid ${({ theme }) => theme.keyline};
      }

      ${Item}:nth-child(odd) {
        border-left: none;
      }
    }
  }

  @media (${mobileXXLargeMax}) {
    border-radius: 20px;
    padding: 10px;
    justify-content: flex-start;

    &.total-items-4,
    &.total-items-3 {
      ${Item} {
        flex: 0 0 50%;
      }

      ${Item}:nth-child(even) {
        border-left: 1px solid ${({ theme }) => theme.keyline};
      }

      ${Item}:nth-child(odd) {
        border-left: none;
      }
    }
  }

  ${Item}:first-child {
    border-left: none;
  }
`;
